import { connect } from 'react-redux';
import { navigateInstitutionAdminSettings } from 'src/ReduxStorage/InstitutionAdminSettings/dispatchers';
import { selectQueryObject } from '../../../../ReduxStorage/location/selectors.common';
import { ReduxState } from '../../../../ReduxStorage/state';
import { LearnersPage } from './components';

export const ConnectedLearnersPage = connect(
  (state: ReduxState) => ({
    queryObject: selectQueryObject(state),
  }),
  {
    navigateTo: navigateInstitutionAdminSettings,
  }
)(LearnersPage);
